import translations from "../assets/locales/fa.json";

type TranslationDict = { [key: string]: TranslationNode };
type TranslationNode = string | RecursiveArray | TranslationDict;
type RecursiveArray = Array<TranslationNode>;

function getTranslationResult(tKey: string): TranslationNode {
  const path = tKey.split(".");
  let res: TranslationNode = translations as unknown as TranslationNode;
  for (let i = 0; i < path.length; i += 1) {
    const node = res as TranslationDict;
    if (node?.[path[i]]) res = node[path[i]];
    else res = path[i];
  }
  return res;
}

function replaceVars(trans: string, vars: Record<string, unknown>): string {
  let result = trans?.replace(/{{ /g, "{{").replace(/ }}/g, "}}");
  if (vars) {
    Object.entries(vars)?.forEach(([key, value]) => {
      if (typeof value === "string" || typeof value === "number") {
        result = result?.replace(RegExp(`{{${key}}}`, "g"), String(value));
      }
    });
  }
  return result;
}

function loopArr(transArr: TranslationNode, vars: Record<string, unknown>): TranslationNode {
  if (typeof transArr === "string") return replaceVars(transArr, vars);
  return Array.isArray(transArr) ? transArr.map((trans) => loopArr(trans, vars)) : transArr;
}

/**
 * Server-safe translation helper. Mirrors the client `useAppTranslation` lookup
 * but is usable outside of React (e.g. inside server actions).
 */
export function translate(tKey: string, vars: Record<string, unknown> = {}): string {
  const result = getTranslationResult(tKey);
  return replaceVars(typeof result === "string" ? result : "", vars);
}

export { getTranslationResult, replaceVars, loopArr };
